import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { AuthService } from "src/app/shared/services/auth/auth.service";
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-shop-single',
  templateUrl: './shop-single.component.html',
  styleUrls: ['./shop-single.component.scss']
})
export class ShopSingleComponent implements OnInit {

  productSingle: any = {};
  productRequest: any = {};
  productList: any = "";
  is_authenticate_user: boolean = false;
  sizeoutstock: boolean = true;
  sizeinstock: boolean = false;
  cartRequest: any = {};
  user: any = "";
  selectedsize: any = "";
  sizeavailable: any = 0;
  constructor(private allpagesService: AllPageService,
    private activatedRoute: ActivatedRoute,
    public authService: AuthService,
    private router: Router,) { }
  slideshopConfig = {
    //dots: true,
    infinite: true,
    arrows: true,
    slidesToShow: 3,
    autoplay: false,
    speed: 500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  ngOnInit() {

    this.authService.$user.subscribe((data) => {
      console.log("login chhhhe");
      console.log(data);
      if (data) {
        //console.log("login chhhhe j");
        //console.log(data);
        this.user = data;
        //console.log(this.user.appuser_id);
        //this.checkautoLogin();
        //this.checkcart();
        //this.checkshopcart();
        this.cartRequest = {
          auth_key: this.user.auth_key,
        };
      } else {
        this.user = null;
        //console.log("login nathi");
      }
    });

    this.allpagesService.getProductMaster().then((data) => {
      this.productList = data;
      console.warn(this.productList);
    });

    this.activatedRoute.params.subscribe((data) => {
      if (data.slug) {
        this.getProduct(data.slug);
      }
    });

  }

  getProduct(productslug) {
    this.productRequest.slug = productslug;
    let request = Object.assign({}, this.productRequest)
    this.allpagesService.getProductSingle(request).then((data) => {
      if(data.status == 1)
        {
      this.productSingle = data.data || {};
    this.sizeavailable = data.data.product_size.length;
      console.warn(this.productSingle);
      setTimeout(function () {


        jQuery("#minus_btn").click(function () {
          var qtyval = jQuery("#quantity").val();
          if (qtyval > 1) {
            qtyval = parseInt(qtyval) - 1;
            jQuery("#quantity").val(qtyval);
          }
        });
        jQuery("#plus_btn").click(function () {
          var qtyval = jQuery("#quantity").val();
          qtyval = parseInt(qtyval) + 1;
          jQuery("#quantity").val(qtyval);
        });

        jQuery(".increment-quantity").click((e) => {

          //var dataid = e.currentTarget.id;
          var qtyval = jQuery("#quantity").val();


          qtyval = parseInt(qtyval) + 1;
          jQuery("#quantity").val(qtyval);
          this.generalCount = true;
        });
        jQuery(".decrement-quantity").click((e) => {

          //var dataid = jQuery(this).attr('id');
          var qtyval = jQuery("#quantity").val();

          if (qtyval > 1) {
            qtyval = parseInt(qtyval) - 1;
            jQuery("#quantity").val(qtyval);
            this.generaladAdultCount = qtyval;
          }
        });


      }, 1000);
    }
    else{
      this.router.navigate(['/shop']);
    }
    });
  }

  sizeaction() {
    this.selectedsize = jQuery("#select_size").val();
    console.warn(this.selectedsize);
    this.productSingle.product_size.forEach((size) => {
     if(size.product_size_master_id == this.selectedsize){ 
        if(size.availability == 'OutOfStock'){
          this.sizeoutstock = false;
          this.sizeinstock = true;
        } else if(size.availability == 'InStock'){
          this.sizeoutstock = true;
          this.sizeinstock = false;        
        }

     } 
      
    });
  
  }

  add_to_cart() {
    if (this.authService.isLoggedIn == true) {

      this.is_authenticate_user = true;
      if(this.sizeavailable > 0 && this.selectedsize == ''){
        alert("please select size");
        return false;
      }else{
        this.cartRequest = {
          auth_key: this.user.auth_key,
          product_master_id: this.productSingle.product_master_id,
          product_size_master_id: this.selectedsize,
          quantity: jQuery("#quantity").val()
        };
        let request: any = {
        };
        request = Object.assign({}, this.cartRequest);
        this.authService.addUserCart(request).then(
          (res) => {
            if (res.status == 1) {
              this.router.navigate(['/shop-cart']);
            }
            console.log(res.data);
            /*this.addedtocartPopup();*/
          }).catch((err) => {
            //console.log(err);
          });
      }
    } else {
      this.router.navigate(['/login']);
    }
  }
}
